/**
 * The words of the phone's Phone section (piece 35, *Calls through the office number*; decision 11880): the section's
 * heading and its three entries, Recents, Voicemail and Texts, spread into the one string lookup.
 */
export const PHONE_SCREEN_STRINGS = {
  'mobile.tab.phone': 'Phone',
  'mobile.phone.recents.title': 'Recents',
  'mobile.phone.filter.label': 'Show calls',
  'mobile.phone.filter.all': 'All',
  'mobile.phone.filter.missed': 'Missed',
  'mobile.phone.filter.voicemail': 'Voicemail',
  'mobile.phone.kind.inbound': 'Incoming call',
  'mobile.phone.kind.outbound': 'Outgoing call',
  'mobile.phone.kind.missed': 'Missed call',
  'mobile.phone.kind.voicemail': 'Voicemail',
  'mobile.phone.status.missed': 'Missed',
  'mobile.phone.status.voicemail': 'Voicemail',
  'mobile.phone.unknownNumber': 'Unknown number',
  'mobile.phone.recents.none': 'No calls yet. A call to or from one of the company’s numbers you answer lists here.',
  'mobile.phone.recents.noneMissed': 'No missed calls.',
  'mobile.phone.recents.noneVoicemail': 'No voicemail.',
  'mobile.phone.showMore': 'Show More',
  'mobile.phone.detail.call': 'Call',
  'mobile.phone.detail.number': 'Number',
  'mobile.phone.detail.ourNumber': 'Our Number',
  'mobile.phone.detail.time': 'Time',
  'mobile.phone.detail.length': 'Length',
  'mobile.phone.detail.recording': 'Recording',
  'mobile.phone.detail.record': 'Record',
  'mobile.phone.voicemail.title': 'Voicemail',
  'mobile.phone.voicemail.none': 'No voicemail yet. A message left on one of the company’s numbers you answer lists here.',
  'mobile.phone.voicemail.play': 'Play',
  'mobile.phone.voicemail.openRecord': 'Open Record',
  'mobile.phone.voicemail.completed': 'Done',
  'mobile.phone.voicemail.noTranscript': 'No transcript yet.',
  'mobile.phone.voicemail.noRecording': 'The recording did not arrive.',
  'mobile.phone.texts.title': 'Texts',
  'mobile.phone.texts.none': 'No texts yet. A text to one of the company’s numbers you answer lists here.',
  'mobile.phone.texts.on': 'On {number}',
  'mobile.phone.texts.companyNumber': 'the company number',
  'mobile.phone.texts.unanswered': '{count} New',
  'mobile.phone.texts.boxFrom': 'Text to {number} from {from}',
  'mobile.phone.texts.unsent': 'The text could not be saved on this phone and the server did not answer, so it was not sent. Press Send again once the phone has a signal.',
  'mobile.phone.texts.noPerson': 'This number is on no Person’s record, so a reply cannot be sent from the phone. Add it to a Person on the website first.',
  'mobile.phone.texts.noReply': 'A reply cannot be sent from this number: no text service is connected, or the number is retired.',
} as const;
